<ejs-dialog target=".dialogs" class="steps-dialog" [visible]='visible' [animationSettings]='dialogService.getAnimationSettings()' [resizeHandles]='dialogService.getResizeHandleDirection()' [position]='dialogService.getPosition()' [isModal]="true" [allowDragging]="false" [width]="'60%'" [height]="'60vh'" [zIndex]="999" [showCloseIcon]="false">
  <ng-template #header class="p-1">
    <app-step-header [steps]="steps" [(activeStep)]="activeStep" [stepIcons]="stepIcons" [showProgress]="false"></app-step-header>
  </ng-template>
  <ng-template #content>
    <div class="d-flex h-100">
      <!-- Left Column -->
      <div class="col-md-4 col-12 d-none d-md-flex flex-column left-container h-100 p-3">
        <div class="text-center mb-4">
          <app-headline [title]="'SHAREPOSTTITLE' | translate" [type]="'h5'"></app-headline>
        </div>
        <app-step-content [steps]="steps" [(activeStep)]="activeStep" [stepIcons]="stepIcons" [showProgress]="false"></app-step-content>
      </div>

      <!-- Right Column -->
      <div class="col-md-8 col-12 d-flex flex-column flex-grow-1 right-container h-100 overflow-y-auto p-3">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <div class="d-flex align-items-center">
            <app-headline [title]="steps[activeStep]" [type]="'h5'"></app-headline>
            <div class="ms-2">
              <app-tooltip [icon]="'help'" [iconClass]="'fs-5 p-1'" [text]="('SHAREHELP' + activeHelpStepIndex | translate)" [width]="'300px'" [height]="'100px'" [cssClass]="'helpTooltip p-2'" [opensOn]="'Click'"></app-tooltip>
            </div>
          </div>
          <app-form-button [style]="'btn'" (click)="close()" [cssClass]="'btn-close'"></app-form-button>
        </div>
        <div
          class="custom-scrollbar overflow-y-auto"
          (scrollend)="layoutService.setScrollToEnd($event, 'share-page-' + activeStep)"
          >
          <form class="p-1 d-flex flex-column h-100">
            @switch (activeStepKey) {
              @case ('news') {
                <app-headline
                  [type]="'h6'"
                  [title]="'SHARENEWSCONTENTSECTIONTITLE' | translate"
                  >
                </app-headline>
                <div class="mb-2">
                  <app-form-label
                    [label]="'SHARENEWSTITLELABEL' | translate"
                    [maxChars]="100"
                    [currentChars]="shareNewsForm.controls['title'].value?.length ?? 0"
                    >
                  </app-form-label>
                  <app-form-input
                    [placeholder]="('SHARENEWSTITLEPLACEHOLDER' | translate)"
                    [label]="('SHARENEWSTITLELABEL' | translate)"
                    [errorText]="('SHARENEWSTITLEREQUIRED' | translate)"
                    [fCN]="'title'"
                    [fG]="shareNewsForm"
                    [maxChars]="100"
                    >
                  </app-form-input>
                </div>
                <div class="mb-2">
                  <app-form-label
                    [label]="'SHARENEWSMESSAGEPLACEHOLDER' | translate"
                    [maxChars]="1000"
                    [currentChars]="getNewsMessageCharCount()"
                    >
                  </app-form-label>
                  <app-form-textarea
                    [fCN]="'message'"
                    [fG]="shareNewsForm"
                    [rows]="4"
                    [richText]="true"
                    [showCharCounter]="false"
                    [maxChars]="1000"
                    [style]="'block'"
                    >
                  </app-form-textarea>
                </div>
                <app-headline
                  [type]="'h6'"
                  [title]="'SHARENEWSMEDIASECTIONTITLE' | translate"
                  >
                </app-headline>
                <div class="mb-2">
                  <app-form-label
                    [label]="'SHARENEWSMEDIATOEDIT' | translate"
                    >
                  </app-form-label>
                  <div class="d-flex flex-wrap gap-2">
                    <app-document-selector
                      [files]="selectableNewsFiles()"
                      (selectedFiles)="shareNewsForm.controls['files'].setValue($event)"
                      >
                    </app-document-selector>
                  </div>
                </div>
                <app-headline
                  [type]="'h6'"
                  [title]="'SHARENEWSTIMINGSECTIONTITLE' | translate"
                  >
                </app-headline>
                <div class="mb-2">
                  <app-form-label
                    [label]="'SHARENEWSSTARTDATETITLE' | translate"
                    >
                  </app-form-label>
                  <app-form-date-time
                    [fG]="shareNewsForm"
                    [fCN]="'startDate'"
                    [cssClass]="isEndDateOrderInvalid() ? 'e-error' : ''"
                    [placeholder]="'SHARENEWSSTARTDATEPLACEHOLDER' | translate"
                    >
                  </app-form-date-time>
                </div>
                <div class="mb-2">
                  <app-form-label
                    [label]="'SHARENEWSENDDATETITLE' | translate"
                    >
                  </app-form-label>
                  <app-form-date-time
                    [fG]="shareNewsForm"
                    [fCN]="'endDate'"
                    [cssClass]="hasSchedulingError() ? 'e-error' : ''"
                    [placeholder]="'SHARENEWSENDDATEPLACEHOLDER' | translate"
                    >
                  </app-form-date-time>
                  @if (hasSchedulingError()) {
                    <div class="e-error mt-1">{{ getSchedulingErrorMessage() }}</div>
                  }
                </div>
                <app-headline
                  [type]="'h6'"
                  [title]="'SHARENEWSSETTINGSSECTIONTITLE' | translate"
                  >
                </app-headline>
                <div class="mb-2">
                  <app-form-label
                    [label]="'SHARENEWSSETTINGSTITLE' | translate"
                    >
                  </app-form-label>
                  <app-form-label
                    [label]="'SHARENEWSALLOWCOMMENTSTITLE' | translate"
                    >
                  </app-form-label>
                  <div class="d-flex flex-row flex-wrap gap-2">
                    <div class="m-2">
                      <app-form-radio
                        [fG]="shareNewsForm"
                        [fCN]="'allowComments'"
                        [value]="true"
                        [placeholder]="'TRUE' | translate"
                        [cssClass]="'e-normal'"
                        >
                      </app-form-radio>
                    </div>
                    <div class="m-2">
                      <app-form-radio
                        [fG]="shareNewsForm"
                        [fCN]="'allowComments'"
                        [value]="false"
                        [placeholder]="'FALSE' | translate"
                        [cssClass]="'e-normal'"
                        >
                      </app-form-radio>
                    </div>
                  </div>
                  <app-form-label
                    [label]="'SHARENEWSALLOWSHARETITLE' | translate"
                    >
                  </app-form-label>
                  <div class="d-flex flex-row flex-wrap gap-2">
                    <div class="m-2">
                      <app-form-radio
                        [fG]="shareNewsForm"
                        [fCN]="'allowSharing'"
                        [value]="true"
                        [placeholder]="'TRUE' | translate"
                        [cssClass]="'e-normal'"
                        >
                      </app-form-radio>
                    </div>
                    <div class="m-2">
                      <app-form-radio
                        [fG]="shareNewsForm"
                        [fCN]="'allowSharing'"
                        [value]="false"
                        [placeholder]="'FALSE' | translate"
                        [cssClass]="'e-normal'"
                        >
                      </app-form-radio>
                    </div>
                  </div>
                  <app-form-label
                    [label]="'NEWSISIMPORTANT' | translate"
                    >
                  </app-form-label>
                  <div class="row mb-2">
                    <div class="col-6">
                      <app-form-checkbox
                        [fCN]="'is_important'"
                        [fG]="shareNewsForm"
                        [cssClass]="'pb-1 lh-base'"
                        [labelPosition]="'After'"
                        [label]="'NEWSMARKASIMPORTANT' | translate"
                        >
                      </app-form-checkbox>
                    </div>
                  </div>
                </div>
                <app-headline
                  [type]="'h6'"
                  [title]="'SHARENEWSRECIPIENTSSECTIONTITLE' | translate"
                  >
                </app-headline>
                <app-form-label [label]="'NEWSEDITRECIPIENTS' | translate"></app-form-label>
                <div class="mb-2">
                  @if (canCreateForAllRecipients()) {
                    <app-form-radio
                      [fG]="shareNewsForm"
                      [fCN]="'recipients'"
                      [value]="'all'"
                      [placeholder]="'NEWSEDITRECIPIENTSALL' | translate"
                      [cssClass]="'e-normal'"
                      >
                    </app-form-radio>
                  }
                  @if (shareNewsForm.controls['recipients'].value === 'all' && canCreateForAllRecipients()) {
                    <div class="mt-2 form-check">
                      <app-form-checkbox
                        [fG]="shareNewsForm"
                        [fCN]="'is_recipients_all_push'"
                        [cssClass]="'pb-1 lh-base'"
                        [labelPosition]="'After'"
                        [label]="'NEWSEDITRECIPIENTSALLPUSH'"
                        >
                      </app-form-checkbox>
                    </div>
                  }
                </div>
                <div class="mb-2">
                  @if (canCreateForSelectionRecipients()) {
                    <app-form-radio
                      [fG]="shareNewsForm"
                      [fCN]="'recipients'"
                      [value]="'selection'"
                      [placeholder]="'NEWSEDITRECIPIENTSSELECTION' | translate"
                      >
                    </app-form-radio>
                  }
                  @if (shareNewsForm.controls['recipients'].value !== 'all' && canCreateForSelectionRecipients()) {
                    <div class="mt-2">
                      <app-form-user-group-mail
                        [allowEmails]="false"
                        [allowPush]="true"
                        [method]="canCreateForUserRecipients() && canCreateForGroupRecipients() ? 'userGroup' : (canCreateForUserRecipients() ? 'user' : 'group')"
                        [hasError]="isUserGroupSelectionError"
                        [(user)]="participantsUserIDs"
                        [(groups)]="participantsGroupIDs"
                        (userChange)="participantsUserIDs = $event; shareNewsForm.controls['participantsUserIDs'].setValue($event); isUserGroupSelectionError = false"
                        (groupsChange)="participantsGroupIDs = $event; shareNewsForm.controls['participantsGroupIDs'].setValue($event); isUserGroupSelectionError = false"
                        (pushUserIDsChange)="pushUserIDs = $event; shareNewsForm.controls['pushUserIDs'].setValue($event)"
                        (pushGroupIDsChange)="pushGroupIDs = $event; shareNewsForm.controls['pushGroupIDs'].setValue($event)"
                        >
                      </app-form-user-group-mail>
                    </div>
                  }
                </div>
              }
              @case ('chat') {
                <div class="mb-3">
                  <app-form-label
                    [label]="'SHARESEARCHCHATROOMLABEL' | translate"
                    >
                  </app-form-label>
                  <app-form-input
                    [type]="'search'"
                    [hasErrorField]="false"
                    [placeholder]="('SHARESEARCHCHATROOMSEARCHPLACEHOLDER' | translate)"
                    [iconFront]="'search'"
                    [iconBack]="'close'"
                    [iconClickType]="'back'"
                    [fCN]="'roomSearch'"
                    [fG]="shareChatForm"
                    (iconBackClick)="filterResults()"
                    (returnKeyPress)="filterResults()"
                    >
                  </app-form-input>
                </div>
                <div class="mb-3">
                  <div class="d-flex justify-content-between align-items-center mb-2">
                    <app-form-label [label]="'SHARESELECTCHATROOMSLABEL' | translate"></app-form-label>
                    <div class="dropdown">
                      <button
                        type="button"
                        class="btn btn-link p-0 text-muted"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        [attr.aria-label]="('SRMOREOPTIONS' | translate)"
                        >
                        <app-tooltip
                          [text]="('SHARESELECTEDCHATROOMSOPTIONTOOLTIP' | translate)"
                          [opensOn]="'Auto'"
                          [position]="'BottomCenter'"
                          >
                          <app-icon-badge [style]="'notification'" [icon]="'more_vert'"></app-icon-badge>
                        </app-tooltip>
                      </button>
                      <ul class="dropdown-menu dropdown-menu-end">
                        <li><app-link (click)="selectAllRooms()" [title]="('SELECTALL' | translate)" [style]="'dropdown'">{{ ('SELECTALL' | translate) }}</app-link></li>
                        <li><app-link (click)="removeAllSelectedRooms()" [title]="('REMOVESELECTED' | translate)" [style]="'dropdown'">{{ ('REMOVESELECTED' | translate) }}</app-link></li>
                      </ul>
                    </div>
                  </div>
                  @for (room of selectableChatRooms(); track room.id; let roomIndex = $index) {
                    <div class="card selected-chat-rooms_when_share mb-2">
                      <div class="d-flex align-items-center justify-content-between">
                        <div class="remove-icon-column d-flex align-items-center justify-content-center border-end p-2">
                          <app-form-button [cssClass]="'e-link text-muted p-0'" [icon]="'close'" [iconClass]="'fs-5'"></app-form-button>
                        </div>
                        <div class="d-flex align-items-center flex-grow-1 ps-2">
                          <div class="e-avatar e-avatar-circle e-avatar-small me-2">
                            @if(room?.display_avatar?.path) {
                              <img
                                [ngSrc]="room?.display_avatar?.path!"
                                alt="profile_pic"
                                width="40"
                                height="40"
                                />
                            } @else {
                              @if((room?.users_count ?? 0) > 2) {
                                <app-icon-badge
                                  [style]="'default'"
                                  [icon]="'group'"
                                  [fontSize]="'fs-3'"
                                  [fontColor]="'text-white'"
                                  >
                                </app-icon-badge>
                              } @else {
                                <app-icon-badge
                                  [style]="'default'"
                                  [icon]="'perm_identity'"
                                  [fontSize]="'fs-3'"
                                  [fontColor]="'text-white'"
                                  >
                                </app-icon-badge>
                              }
                            }
                          </div>
                          <div class="lh-1">
                            <app-tooltip [text]="room?.display_name ?? ''" [opensOn]="'Auto'">
                              <app-headline [type]="'h6'" [title]="room?.display_name ?? ''" [class]="'text-muted fs-small'"></app-headline>
                            </app-tooltip>
                          </div>
                        </div>
                        <div class="checkbox-column d-flex align-items-center justify-content-center border-start p-2">
                          <app-form-checkbox [fG]="getFormArray()" [fCN]="roomIndex.toString()" [cssClass]="'pb-1'"></app-form-checkbox>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              }
              @case ('mail') {
                <div class="mb-2">
                  <app-form-label
                    [label]="'SHAREDESTINATIONEMAILLABEL' | translate"
                    [currentChars]="shareMailForm.controls['recipientEmail'].value?.length ?? 0"
                    >
                  </app-form-label>
                  <app-form-input
                    [placeholder]="('SHAREADDEMAILPLACEHOLDER' | translate)"
                    [label]="('SHAREADDEMAILPLACEHOLDER' | translate)"
                    [errorText]="('SHAREEMAILREQUIRED' | translate)"
                    [fCN]="'recipientEmail'"
                    [fG]="shareMailForm"
                    >
                  </app-form-input>
                </div>
                <div class="mb-2">
                  <app-form-label
                    [label]="'SHAREEMAILSUBJECTLABEL' | translate"
                    [currentChars]="shareMailForm.controls['subject'].value?.length ?? 0"
                    >
                  </app-form-label>
                  <app-form-input
                    [placeholder]="('SHAREEMAILSUBJECTPLACEHOLDER' | translate)"
                    [label]="('SHAREEMAILSUBJECTPLACEHOLDER' | translate)"
                    [errorText]="('SHAREEMAILSUBJECTREQUIRED' | translate)"
                    [fCN]="'subject'"
                    [fG]="shareMailForm"
                    >
                  </app-form-input>
                </div>
                <div class="mb-2">
                  <app-form-label
                    [label]="'SHAREEMAILMESSAGEPLACEHOLDER' | translate"
                    [currentChars]="shareMailForm.controls['message'].value?.length ?? 0"
                    >
                  </app-form-label>
                  <app-form-textarea
                    [fCN]="'message'"
                    [fG]="shareMailForm"
                    [rows]="4"
                    [richText]="true"
                    [style]="'block'"
                    >
                  </app-form-textarea>
                </div>
                <div class="mb-2">
                  <app-form-label
                    [label]="'SHAREEMAILMEDIATOEDIT' | translate"
                    >
                  </app-form-label>
                  <div class="d-flex flex-wrap gap-2">
                    <app-document-selector
                      [files]="selectableMailFiles()"
                      (selectedFiles)="shareMailForm.controls['files'].setValue($event)"
                      >
                    </app-document-selector>
                  </div>
                </div>
              }
              @case ('link') {
                <div class="mb-2">
                  <app-form-label
                    [label]="'SHARELINKMENUTEXT' | translate"
                    >
                  </app-form-label>
                  <input
                    class="e-input"
                    [value]="shareLink"
                    readonly
                    aria-readonly="true"
                  />
                </div>
                <div class="mt-3">
                  <app-form-button
                    [text]="'COPY' | translate"
                    [cssClass]="'e-primary'"
                    (click)="copyShareLink()"
                    >
                  </app-form-button>
                </div>
              }
              @case ('tv') {
                <div class="mb-2">
                  <app-form-label
                    [label]="'SHARETVTITLELABEL' | translate"
                    >
                  </app-form-label>
                  <app-form-input
                    [placeholder]="('SHARETVTITLEPLACEHOLDER' | translate)"
                    [label]="('SHARETVTITLEPLACEHOLDER' | translate)"
                    [errorText]="('SHARETVTITLEREQUIRED' | translate)"
                    [fCN]="'title'"
                    [fG]="shareTvForm"
                    >
                  </app-form-input>
                </div>
                <app-form-label
                  [label]="'SHARETVINTERNALNAMELABEL' | translate"
                  [maxChars]="30"
                  [currentChars]="shareTvForm.controls['internalNote'].value.length"
                  >
                </app-form-label>
                <div class="row mb-2">
                  <div class="col-md-6">
                    <app-form-input
                      [placeholder]="('SHARETVINTERNALNAMEPLACEHOLDER' | translate)"
                      [label]="('SHARETVINTERNALNAMEPLACEHOLDER' | translate)"
                      [errorText]="('SHARETVINTERNALNAMEREQUIRED' | translate)"
                      [fCN]="'internalNote'"
                      [fG]="shareTvForm"
                      [maxChars]="30"
                      >
                    </app-form-input>
                  </div>
                </div>
                <div class="mb-3">
                  <app-form-label [label]="'SHARETVTEXTCONTENTLABEL' | translate"></app-form-label>
                  <app-form-textarea
                    [placeholder]="('SHARETVTEXTCONTENTPLACEHOLDER' | translate)"
                    [fCN]="'message'"
                    [fG]="shareTvForm"
                    [maxChars]="100"
                    [rows]="4"
                    >
                  </app-form-textarea>
                </div>
                <app-form-label [label]="'SHARETVCHOOSEONEMEDIALABEL' | translate"></app-form-label>
                <div class="fileFolderListContainer d-flex flex-wrap gap-3 p-2">
                  <app-document-selector
                    [files]="selectableTvFiles()"
                    [initialySelected]="false"
                    (selectedFiles)="shareTvForm.controls['files'].setValue($event)"
                    >
                  </app-document-selector>
                </div>
              }
            }
          </form>
        </div>

        <div class="d-flex justify-content-end mt-3 d-none d-md-flex">
          @switch(activeStepKey) {
            @case('news') {
              <app-form-button
                [text]="'SHARE' | translate"
                [disabled]="!canShareNews()"
                [cssClass]="'e-primary'"
                (click)="createNews()"
                >
              </app-form-button>
            }
            @case('chat') {
              <app-form-button
                [text]="'SHARETOCHATANDOPEN' | translate"
                [disabled]="shareChatForm.invalid"
                [cssClass]="'e-primary mx-3'"
                (click)="shareToChat(true)"
                >
              </app-form-button>
              <app-form-button
                [text]="'SHARETOCHAT' | translate"
                [disabled]="shareChatForm.invalid"
                [cssClass]="'e-primary'"
                (click)="shareToChat(false)"
                >
              </app-form-button>
            }
            @case('mail') {
              <app-form-button
                [text]="'SHAREBYMAIL' | translate"
                [disabled]="shareMailForm.invalid"
                [cssClass]="'e-primary'"
                (click)="shareByMail()"
                >
              </app-form-button>
            }
            @case('tv') {
              <app-form-button
                [text]="'PREVIEWTVSHARE' | translate"
                [disabled]="shareTvForm.invalid"
                [cssClass]="'e-primary'"
                (click)="shareTvPreview()"
                >
              </app-form-button>
              <app-form-button
                [text]="'TVSHARE' | translate"
                [disabled]="shareTvForm.invalid"
                [cssClass]="'e-primary'"
                (click)="shareTv()"
                >
              </app-form-button>
            }
          }
          <!--<app-form-button [text]="'SAVE' | translate" [disabled]="shareChatForm.invalid" (click)="save()" [cssClass]="'e-primary mx-auto w-100'"></app-form-button>-->
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #footerTemplate>
    <div class="mt-auto d-md-none col-12 d-flex justify-content-between p-2">
      @switch(activeStepKey) {
        @case('news') {
          <app-form-button
            [text]="'SHARE' | translate"
            [disabled]="!canShareNews()"
            [cssClass]="'e-primary'"
            (click)="createNews()"
            >
          </app-form-button>
        }
        @case('chat') {
          <app-form-button
            [text]="'SHARETOCHATANDOPEN' | translate"
            [disabled]="shareChatForm.invalid"
            [cssClass]="'e-primary'"
            (click)="shareToChat(true)"
            >
          </app-form-button>
          <app-form-button
            [text]="'SHARETOCHAT' | translate"
            [disabled]="shareChatForm.invalid"
            [cssClass]="'e-primary'"
            (click)="shareToChat(false)"
            >
          </app-form-button>
        }
        @case('mail') {
          <app-form-button
            [text]="'SHAREBYMAIL' | translate"
            [disabled]="shareMailForm.invalid"
            [cssClass]="'e-primary'"
            (click)="shareByMail()"
            >
          </app-form-button>
        }
        @case('tv') {
          <app-form-button
            [text]="'PREVIEWTVSHARE' | translate"
            [disabled]="shareTvForm.invalid"
            [cssClass]="'e-primary'"
            (click)="shareTvPreview()"
            >
          </app-form-button>
        }
      }
    </div>
  </ng-template>
</ejs-dialog>
